// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./views/Login/bg-image.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Iconwallpaper2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0 !important;
  padding: 0 !important;
  /* font-family         : -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

html,
body,
.login {
  padding: 0;
  height: 100%;
  font-family: 'Roboto', sans-serif;
}

.login {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: cover;
  /* background: black; */
}

.wallpaper--icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-color: #fcfcfc;
  background-attachment: fixed;
  font-family: 'Roboto', sans-serif;
}

/* svg map starts*/
/* to remove the black and white circle on focus of svg map */
path:focus {
  outline: none;
}
/* svg map ends*/

/*Searchbar starts*/
.searchBarOuterWrapper {
  transform: scale(1);
  z-index: 99;
}

/*Searchbar ends*/
/* profilecard starts*/
/* [class*="profileSection"] {
  transform: translate3d(0, 0, 0);
  animation: fadeInOut 5s 2, autoSwipeUp 10s steps(2, end) 1 both;
} */
@keyframes moveForward0 {
  0% {
    transform: translate3d(58px, 0, 0) scale(0.92);
  }

  100% {
    transform: translate3d(-30px, 0, 0) scale(0.96);
  }
}

@keyframes moveForward1 {
  0% {
    transform: translate3d(30px, 0, 0) scale(0.96);
  }

  100% {
    transform: translate3d(-10px, 0, 0) scale(1);
  }
}

@keyframes autoSwipeUp {
  0% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, -872px, 0)
  }
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  90% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes bgColorFade {
  from {
    background-color: #f0fffb
  }

  to {
    background-color: #ffffff
  }
}

@keyframes indicatorProgress {
  0% {
    height: 0;
  }

  100% {
    height: 100%;
  }
}

@keyframes pageLoader {
  0% {
    opacity: 1;
  }

  75% {
    opacity: 1;
  }

  99% {
    z-index: 9999;
  }

  100% {
    opacity: 0;
    z-index: -1;
  }
}

@keyframes profileFade {
  from {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

.scrollDownElem {
  position: absolute;
  top: 82%;
  left: 96%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 30px;
}

.scrollDown__Icons {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.scrollDown__Icons--arow {
  position: absolute;
  top: 20px;
  color: #ccc;
  animation: arrow 700ms linear infinite;
}

.qualificationsWrapper--Mini {
  flex: 1 1;
}

.qualificationsWrapper--Mini>div {
  padding-top: 7px !important;
}

.qualificationsWrapper--Mini div[role="listbox"],
.qualificationsWrapper--Mini div.listbox {
  /* width: 900px; */
  /* left      : -5%; */
  left: -9.5%;
  /* transform : translate3d(0, 50px, 0) !important; */
  transform: translate3d(0, 0px, 0) !important;
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
}

.qualificationsWrapper--Mini input {
  max-height: 22px;
}

.qualificationsWrapper--Mini input.qualsInput {
  padding: 10px 0 20px;
}

.qualificationsWrapper--Mini .outerPholder {
  padding: 2px 0 !important;
}

.qualificationsWrapper--Mini .inputfocused {
  top: 77.5px !important;
  left: 60px !important;
  padding: 14.5px !important;
}

.qualificationsWrapper--Mini .box_label+div {
  max-height: 26px
}

.qualificationsWrapper--Mini .box_label+div>div>span {
  max-width: 164px !important;
}

.qualificationsWrapper--Mini .box_label+div>div+span {
  font-size: 12px
}

/* profilecard ends*/
.relevantTag {
  margin: 37px 10px 45px 8px;
  width: 98%;
  height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  border-bottom: 1px solid #C4C4C4;
  text-align: center;
}

.relevantTag>p {
  border: 1px solid #C4C4C4;
  color: #5BC2A8;
  background: white;
  border-radius: 25px;
  width: auto;
  padding: 8px 10px;
}

.relevantTag>p>span {
  color: #14967B;
  font-weight: 500;
  text-transform: capitalize;
}

/* algolia customization starts */
.ais-InfiniteHits-item,
.ais-InfiniteResults-item,
.ais-Hits-item,
.ais-Results-item {
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
}

/* .ais-InfiniteResults-item, .ais-Hits-item{
  margin-left: 13px!important;
} */
li.ais-Hits-item {
  width: auto !important;
}

.flex-container-pagination {
  position: relative;
  margin-top: 17px;
}

.flex-container-pagination.flex-container-pagination-list {
  margin-top: 0;
}

.ais-Pagination.ais-Pagination--noRefinement {
  display: none;
}

.ais-SearchBox {
  margin: 12px 0 !important;
}

/* for discovery first card  */
[class*='listViewWrapper'] .ais-InfiniteHits-item:first-child {
  margin-top: 0
}

.ais-InfiniteHits-item:nth-child(4n+0) .imgPholder,
.listItemWrapper:nth-child(4n+0) .imgPholder {
  background-color: #B9E4D9;
}

.ais-InfiniteHits-item:nth-child(4n+1) .imgPholder,
.listItemWrapper:nth-child(4n+1) .imgPholder {
  background-color: #FDEBB4;
}

.ais-InfiniteHits-item:nth-child(4n+2) .imgPholder,
.listItemWrapper:nth-child(4n+2) .imgPholder {
  background-color: #FFCDD3;
}

.ais-InfiniteHits-item:nth-child(4n+3) .imgPholder,
.listItemWrapper:nth-child(4n+3) .imgPholder {
  background-color: #E4BDDB;
}

.ais-InfiniteHits-item:nth-child(4n+0) .imgPholder p,
.listItemWrapper:nth-child(4n+0) .imgPholder p {
  color: #5BC2A8;
}

.ais-InfiniteHits-item:nth-child(4n+1) .imgPholder p,
.listItemWrapper:nth-child(4n+1) .imgPholder p {
  color: #FCD450;
}

.ais-InfiniteHits-item:nth-child(4n+2) .imgPholder p,
.listItemWrapper:nth-child(4n+2) .imgPholder p {
  color: #EF9A9B;
}

.ais-InfiniteHits-item:nth-child(4n+3) .imgPholder p,
.listItemWrapper:nth-child(4n+3) .imgPholder p {
  color: #C361B1;
}

/* pagination styling for card view */
.ais-Pagination {
  position: absolute;
  top: 48%;
  left: -6.62%;
  width: 116%;
  margin-top: 0 !important;
}

.ais-Pagination .ais-Pagination-list {
  justify-content: space-between;
}

.ais-Pagination .ais-Pagination-item.ais-Pagination-item--selected.ais-Pagination-item--page {
  display: none;
}

.ais-Pagination-item a.ais-Pagination-link,
.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link {
  height: 40px;
  text-align: center;
  line-height: 34px;
  padding: 0;
  width: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 2px solid #14967B;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 10%);
  color: #14967B;
  font-size: 40px;
}

.ais-Pagination-item a.ais-Pagination-link:hover,
.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link:hover {
  background-color: #b9f0e1;
  color: #14967B;
}

.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link {
  border: 2px solid #aaa;
  /* box-shadow      : 0px 4px 4px rgb(0 0 0 / 10%); */
  color: #aaa;
  font-size: 40px;
}

.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link:hover {
  background-color: #ffffff;
  color: #aaa;
}

/* algolia customization ends */

.gsleekScroll {
  width: 870px;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1 1;
  margin: 0 15px;
}

.gsleekScroll::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

.gsleekScroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.gsleekScroll::-webkit-scrollbar-thumb:hover {
  background: #5BC2A8;
  cursor: pointer;
}

.gsleekScroll::-webkit-scrollbar-track {
  background: #fafafa;
}

/* Responsive card starts*/
@media only screen and (min-width: 600px) {

  #cardWrapper,
  #cardWrapper1 {
    width: 500px
  }
}

@media only screen and (min-width: 768px) {

  #cardWrapper,
  #cardWrapper1 {
    width: 700px
  }
}

@media only screen and (min-width: 992px) {

  #cardWrapper,
  #cardWrapper1 {
    width: 860px
  }

  #cardWrapper_profileLaptop {
    /* profile page for laptop and up */
    width: 992px;
    height: calc(100vh - 185px);
  }

  #cardWrapper_profileLaptop #cardWrapper1 {
    /* profile page loader for laptop and up */
    width: 992px;
  }

  #cardWrapper_profileLaptop #imageWrapper {
    /* profile page for laptop and up */
    height: calc(100vh - 185px);
  }
}

@media only screen and (min-width: 1200px) {

  #cardWrapper,
  #cardWrapper1 {
    width: 860px
  }

  #cardWrapper_profileLaptop {
    width: 1100px;
    height: calc(100vh - 185px);
  }

  #cardWrapper_profileLaptop #cardWrapper1 {
    /* profile page loader for laptop and up */
    width: 1100px;
  }

  #cardWrapper_profileLaptop #imageWrapper {
    /* profile page for laptop and up */
    height: calc(100vh - 185px);
  }
}

@media only screen and (min-width: 1200px) and (min-height: 600px) and (max-height: 750px) {

  #cardWrapper,
  #cardWrapper1 {
    width: 860px;
    height: calc(100vh - 235px);
  }

  #cardWrapper_profileLaptop {
    /* profile page for laptop and up */
    width: 1100px;
    height: calc(100vh - 185px);
  }

  #cardWrapper_profileLaptop #cardWrapper1 {
    /* profile page loader for laptop and up */
    width: 1100px;
  }

  #cardWrapper_profileLaptop #imageWrapper {
    /* profile page for laptop and up */
    height: calc(100vh - 185px);
  }

  #pageBar {
    margin-top: 0;
  }

  #imageWrapper {
    height: calc(100vh - 235px);
  }

  #leftSectionCardId {
    max-width: 35%;
  }
}

@media only screen and (min-width: 1200px) and (min-height: 500px) and (max-height: 599px) {
  #leftSectionCardId {
    max-width: 35%;
  }
}

@media only screen and (min-width: 1700px) {
  #profileNavArrowWrapper {
    width: 1332px;
  }

  #cardWrapper,
  #cardWrapper1 {
    width: 1200px
  }

  #cardWrapper_profileLaptop {
    /* profile page for fullHD */
    width: 1200px;
    height: calc(100vh - 185px);
  }

  #cardWrapper_profileLaptop #imageWrapper {
    /* profile page for fullHD */
    height: calc(100vh - 185px);
  }

  .flex-container-pagination {
    width: 1200px !important;
  }

  .flex-container-pagination.flex-container-pagination-list {
    width: 860px !important;
  }

  .flex-container-pagination.flex-container-pagination-list #cardWrapper1 {
    width: 860px !important;
  }

  .ais-Pagination {
    left: -6.3%;
    width: 113%;
  }

  .searchBarOuterWrapper {
    transform: scale(1.2);
  }

  .MuiTypography-body2 {
    font-size: 1rem;
  }
}

/* Responsive card ends*/`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;EACrB;;iBAEe;EACf,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;EAGE,UAAU;EACV,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,iFAA2E;EAC3E,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mDAA8C;EAC9C,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB,6DAA6D;AAC7D;EACE,aAAa;AACf;AACA,gBAAgB;;AAEhB,mBAAmB;AACnB;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,iBAAiB;AACjB,sBAAsB;AACtB;;;GAGG;AACH;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,oDAAoD;EACpD,4CAA4C;EAC5C,iHAAiH;AACnH;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;AACF;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;;;;EAIE,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;GAEG;AACH;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE;AACF;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,wCAAwC;EACxC,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oDAAoD;EACpD,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,+BAA+B;;AAE/B;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;;EAEE;;IAEE;EACF;AACF;;AAEA;;EAEE;;IAEE;EACF;AACF;;AAEA;;EAEE;;IAEE;EACF;;EAEA;IACE,mCAAmC;IACnC,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA;;EAEE;;IAEE;EACF;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,0CAA0C;IAC1C,aAAa;EACf;;EAEA;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;AACF;;AAEA;;EAEE;;IAEE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,mCAAmC;IACnC,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,0CAA0C;IAC1C,aAAa;EACf;;EAEA;IACE,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE;EACF;;EAEA;IACE,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB","sourcesContent":["body {\n  margin: 0 !important;\n  padding: 0 !important;\n  /* font-family         : -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nhtml,\nbody,\n.login {\n  padding: 0;\n  height: 100%;\n  font-family: 'Roboto', sans-serif;\n}\n\n.login {\n  background: url(\"./views/Login/bg-image.jpg\") no-repeat center center fixed;\n  background-size: cover;\n  /* background: black; */\n}\n\n.wallpaper--icon {\n  background: url(\"./assets/Iconwallpaper2.png\");\n  background-color: #fcfcfc;\n  background-attachment: fixed;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* svg map starts*/\n/* to remove the black and white circle on focus of svg map */\npath:focus {\n  outline: none;\n}\n/* svg map ends*/\n\n/*Searchbar starts*/\n.searchBarOuterWrapper {\n  transform: scale(1);\n  z-index: 99;\n}\n\n/*Searchbar ends*/\n/* profilecard starts*/\n/* [class*=\"profileSection\"] {\n  transform: translate3d(0, 0, 0);\n  animation: fadeInOut 5s 2, autoSwipeUp 10s steps(2, end) 1 both;\n} */\n@keyframes moveForward0 {\n  0% {\n    transform: translate3d(58px, 0, 0) scale(0.92);\n  }\n\n  100% {\n    transform: translate3d(-30px, 0, 0) scale(0.96);\n  }\n}\n\n@keyframes moveForward1 {\n  0% {\n    transform: translate3d(30px, 0, 0) scale(0.96);\n  }\n\n  100% {\n    transform: translate3d(-10px, 0, 0) scale(1);\n  }\n}\n\n@keyframes autoSwipeUp {\n  0% {\n    transform: translate3d(0, 0, 0);\n  }\n\n  100% {\n    transform: translate3d(0, -872px, 0)\n  }\n}\n\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n  }\n\n  10% {\n    opacity: 1;\n  }\n\n  90% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes bgColorFade {\n  from {\n    background-color: #f0fffb\n  }\n\n  to {\n    background-color: #ffffff\n  }\n}\n\n@keyframes indicatorProgress {\n  0% {\n    height: 0;\n  }\n\n  100% {\n    height: 100%;\n  }\n}\n\n@keyframes pageLoader {\n  0% {\n    opacity: 1;\n  }\n\n  75% {\n    opacity: 1;\n  }\n\n  99% {\n    z-index: 9999;\n  }\n\n  100% {\n    opacity: 0;\n    z-index: -1;\n  }\n}\n\n@keyframes profileFade {\n  from {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n.scrollDownElem {\n  position: absolute;\n  top: 82%;\n  left: 96%;\n  transform: translate(-50%, -50%);\n  width: 40px;\n  height: 30px;\n}\n\n.scrollDown__Icons {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.scrollDown__Icons--arow {\n  position: absolute;\n  top: 20px;\n  color: #ccc;\n  animation: arrow 700ms linear infinite;\n}\n\n.qualificationsWrapper--Mini {\n  flex: 1;\n}\n\n.qualificationsWrapper--Mini>div {\n  padding-top: 7px !important;\n}\n\n.qualificationsWrapper--Mini div[role=\"listbox\"],\n.qualificationsWrapper--Mini div.listbox {\n  /* width: 900px; */\n  /* left      : -5%; */\n  left: -9.5%;\n  /* transform : translate3d(0, 50px, 0) !important; */\n  transform: translate3d(0, 0px, 0) !important;\n  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);\n}\n\n.qualificationsWrapper--Mini input {\n  max-height: 22px;\n}\n\n.qualificationsWrapper--Mini input.qualsInput {\n  padding: 10px 0 20px;\n}\n\n.qualificationsWrapper--Mini .outerPholder {\n  padding: 2px 0 !important;\n}\n\n.qualificationsWrapper--Mini .inputfocused {\n  top: 77.5px !important;\n  left: 60px !important;\n  padding: 14.5px !important;\n}\n\n.qualificationsWrapper--Mini .box_label+div {\n  max-height: 26px\n}\n\n.qualificationsWrapper--Mini .box_label+div>div>span {\n  max-width: 164px !important;\n}\n\n.qualificationsWrapper--Mini .box_label+div>div+span {\n  font-size: 12px\n}\n\n/* profilecard ends*/\n.relevantTag {\n  margin: 37px 10px 45px 8px;\n  width: 98%;\n  height: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  border-bottom: 1px solid #C4C4C4;\n  text-align: center;\n}\n\n.relevantTag>p {\n  border: 1px solid #C4C4C4;\n  color: #5BC2A8;\n  background: white;\n  border-radius: 25px;\n  width: auto;\n  padding: 8px 10px;\n}\n\n.relevantTag>p>span {\n  color: #14967B;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n/* algolia customization starts */\n.ais-InfiniteHits-item,\n.ais-InfiniteResults-item,\n.ais-Hits-item,\n.ais-Results-item {\n  padding: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/* .ais-InfiniteResults-item, .ais-Hits-item{\n  margin-left: 13px!important;\n} */\nli.ais-Hits-item {\n  width: auto !important;\n}\n\n.flex-container-pagination {\n  position: relative;\n  margin-top: 17px;\n}\n\n.flex-container-pagination.flex-container-pagination-list {\n  margin-top: 0;\n}\n\n.ais-Pagination.ais-Pagination--noRefinement {\n  display: none;\n}\n\n.ais-SearchBox {\n  margin: 12px 0 !important;\n}\n\n/* for discovery first card  */\n[class*='listViewWrapper'] .ais-InfiniteHits-item:first-child {\n  margin-top: 0\n}\n\n.ais-InfiniteHits-item:nth-child(4n+0) .imgPholder,\n.listItemWrapper:nth-child(4n+0) .imgPholder {\n  background-color: #B9E4D9;\n}\n\n.ais-InfiniteHits-item:nth-child(4n+1) .imgPholder,\n.listItemWrapper:nth-child(4n+1) .imgPholder {\n  background-color: #FDEBB4;\n}\n\n.ais-InfiniteHits-item:nth-child(4n+2) .imgPholder,\n.listItemWrapper:nth-child(4n+2) .imgPholder {\n  background-color: #FFCDD3;\n}\n\n.ais-InfiniteHits-item:nth-child(4n+3) .imgPholder,\n.listItemWrapper:nth-child(4n+3) .imgPholder {\n  background-color: #E4BDDB;\n}\n\n.ais-InfiniteHits-item:nth-child(4n+0) .imgPholder p,\n.listItemWrapper:nth-child(4n+0) .imgPholder p {\n  color: #5BC2A8;\n}\n\n.ais-InfiniteHits-item:nth-child(4n+1) .imgPholder p,\n.listItemWrapper:nth-child(4n+1) .imgPholder p {\n  color: #FCD450;\n}\n\n.ais-InfiniteHits-item:nth-child(4n+2) .imgPholder p,\n.listItemWrapper:nth-child(4n+2) .imgPholder p {\n  color: #EF9A9B;\n}\n\n.ais-InfiniteHits-item:nth-child(4n+3) .imgPholder p,\n.listItemWrapper:nth-child(4n+3) .imgPholder p {\n  color: #C361B1;\n}\n\n/* pagination styling for card view */\n.ais-Pagination {\n  position: absolute;\n  top: 48%;\n  left: -6.62%;\n  width: 116%;\n  margin-top: 0 !important;\n}\n\n.ais-Pagination .ais-Pagination-list {\n  justify-content: space-between;\n}\n\n.ais-Pagination .ais-Pagination-item.ais-Pagination-item--selected.ais-Pagination-item--page {\n  display: none;\n}\n\n.ais-Pagination-item a.ais-Pagination-link,\n.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link {\n  height: 40px;\n  text-align: center;\n  line-height: 34px;\n  padding: 0;\n  width: 40px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 2px solid #14967B;\n  box-shadow: 0px 4px 4px rgb(0 0 0 / 10%);\n  color: #14967B;\n  font-size: 40px;\n}\n\n.ais-Pagination-item a.ais-Pagination-link:hover,\n.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link:hover {\n  background-color: #b9f0e1;\n  color: #14967B;\n}\n\n.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link {\n  border: 2px solid #aaa;\n  /* box-shadow      : 0px 4px 4px rgb(0 0 0 / 10%); */\n  color: #aaa;\n  font-size: 40px;\n}\n\n.ais-Pagination-item.ais-Pagination-item--disabled .ais-Pagination-link:hover {\n  background-color: #ffffff;\n  color: #aaa;\n}\n\n/* algolia customization ends */\n\n.gsleekScroll {\n  width: 870px;\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  flex: 1;\n  margin: 0 15px;\n}\n\n.gsleekScroll::-webkit-scrollbar {\n  width: 5px;\n  height: 8px;\n}\n\n.gsleekScroll::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.gsleekScroll::-webkit-scrollbar-thumb:hover {\n  background: #5BC2A8;\n  cursor: pointer;\n}\n\n.gsleekScroll::-webkit-scrollbar-track {\n  background: #fafafa;\n}\n\n/* Responsive card starts*/\n@media only screen and (min-width: 600px) {\n\n  #cardWrapper,\n  #cardWrapper1 {\n    width: 500px\n  }\n}\n\n@media only screen and (min-width: 768px) {\n\n  #cardWrapper,\n  #cardWrapper1 {\n    width: 700px\n  }\n}\n\n@media only screen and (min-width: 992px) {\n\n  #cardWrapper,\n  #cardWrapper1 {\n    width: 860px\n  }\n\n  #cardWrapper_profileLaptop {\n    /* profile page for laptop and up */\n    width: 992px;\n    height: calc(100vh - 185px);\n  }\n\n  #cardWrapper_profileLaptop #cardWrapper1 {\n    /* profile page loader for laptop and up */\n    width: 992px;\n  }\n\n  #cardWrapper_profileLaptop #imageWrapper {\n    /* profile page for laptop and up */\n    height: calc(100vh - 185px);\n  }\n}\n\n@media only screen and (min-width: 1200px) {\n\n  #cardWrapper,\n  #cardWrapper1 {\n    width: 860px\n  }\n\n  #cardWrapper_profileLaptop {\n    width: 1100px;\n    height: calc(100vh - 185px);\n  }\n\n  #cardWrapper_profileLaptop #cardWrapper1 {\n    /* profile page loader for laptop and up */\n    width: 1100px;\n  }\n\n  #cardWrapper_profileLaptop #imageWrapper {\n    /* profile page for laptop and up */\n    height: calc(100vh - 185px);\n  }\n}\n\n@media only screen and (min-width: 1200px) and (min-height: 600px) and (max-height: 750px) {\n\n  #cardWrapper,\n  #cardWrapper1 {\n    width: 860px;\n    height: calc(100vh - 235px);\n  }\n\n  #cardWrapper_profileLaptop {\n    /* profile page for laptop and up */\n    width: 1100px;\n    height: calc(100vh - 185px);\n  }\n\n  #cardWrapper_profileLaptop #cardWrapper1 {\n    /* profile page loader for laptop and up */\n    width: 1100px;\n  }\n\n  #cardWrapper_profileLaptop #imageWrapper {\n    /* profile page for laptop and up */\n    height: calc(100vh - 185px);\n  }\n\n  #pageBar {\n    margin-top: 0;\n  }\n\n  #imageWrapper {\n    height: calc(100vh - 235px);\n  }\n\n  #leftSectionCardId {\n    max-width: 35%;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (min-height: 500px) and (max-height: 599px) {\n  #leftSectionCardId {\n    max-width: 35%;\n  }\n}\n\n@media only screen and (min-width: 1700px) {\n  #profileNavArrowWrapper {\n    width: 1332px;\n  }\n\n  #cardWrapper,\n  #cardWrapper1 {\n    width: 1200px\n  }\n\n  #cardWrapper_profileLaptop {\n    /* profile page for fullHD */\n    width: 1200px;\n    height: calc(100vh - 185px);\n  }\n\n  #cardWrapper_profileLaptop #imageWrapper {\n    /* profile page for fullHD */\n    height: calc(100vh - 185px);\n  }\n\n  .flex-container-pagination {\n    width: 1200px !important;\n  }\n\n  .flex-container-pagination.flex-container-pagination-list {\n    width: 860px !important;\n  }\n\n  .flex-container-pagination.flex-container-pagination-list #cardWrapper1 {\n    width: 860px !important;\n  }\n\n  .ais-Pagination {\n    left: -6.3%;\n    width: 113%;\n  }\n\n  .searchBarOuterWrapper {\n    transform: scale(1.2);\n  }\n\n  .MuiTypography-body2 {\n    font-size: 1rem;\n  }\n}\n\n/* Responsive card ends*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
